var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHorror = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Halloween-Grim-Reaper--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Halloween Grim Reaper Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.81 21.64 -2.56 -5.05a0.52 0.52 0 0 0 -0.37 -0.27 0.49 0.49 0 0 0 -0.43 0.15 3.4 3.4 0 0 1 -0.7 0.55 0.52 0.52 0 0 0 -0.19 0.66L21 22.54a1 1 0 0 0 0.89 0.55 0.88 0.88 0 0 0 0.45 -0.11 1 1 0 0 0 0.47 -1.34Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92 13.9A1.9 1.9 0 0 0 17 12h-4.6a0.5 0.5 0 0 1 -0.5 -0.5v-2a5 5 0 0 0 -10 0v7a18 18 0 0 1 -0.57 4.34c-0.26 1.1 -0.45 1.9 0 2.48S2.7 24 3.92 24a2.61 2.61 0 0 0 1.79 -0.6 2 2 0 0 1 2.42 0 2.63 2.63 0 0 0 1.79 0.6c1.38 0 2.21 -0.25 2.61 -0.79a2.11 2.11 0 0 0 0.06 -1.94 17.55 17.55 0 0 1 -0.67 -4.77 0.5 0.5 0 0 1 0.5 -0.5H17a1.9 1.9 0 0 0 1.9 -1.9Zm-9.75 -3a2.25 2.25 0 0 1 -4.5 0V10c0 -0.66 0.17 -1.26 2.25 -1.26s2.25 0.6 2.25 1.26Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79 10.23a0.49 0.49 0 0 0 0.44 0.27h1.12a0.5 0.5 0 0 0 0.43 -0.24 0.5 0.5 0 0 0 0 -0.49l-1.58 -3.1a0.51 0.51 0 0 1 0.17 -0.67 26.36 26.36 0 0 1 6.41 -3.27 1 1 0 0 0 0.64 -1 1 1 0 0 0 -0.71 -0.92 13.38 13.38 0 0 0 -8.49 0.73 0.5 0.5 0 0 1 -0.67 -0.22l-0.43 -0.77a1 1 0 1 0 -1.78 0.9Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHorror);
export default ForwardRef;